import { render, staticRenderFns } from "./MapBg.vue?vue&type=template&id=065fcec6&scoped=true"
import script from "./MapBg.vue?vue&type=script&lang=js"
export * from "./MapBg.vue?vue&type=script&lang=js"
import style0 from "./MapBg.vue?vue&type=style&index=0&id=065fcec6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065fcec6",
  null
  
)

export default component.exports